<!--
  ~ Copyright (C) 2019 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="list-questions" tabindex="0" aria-labelledby="choiceGroupQuestionAria">
  <div class="question-aria" id="choiceGroupQuestionAria">{{ 'translations.choiceGroupQuestionAria' | transloco }}</div>

  @if (question?.questionTarget?.feedbackProvider && isFeedbackFor) {
    <ptl-resource-preview
      class="question-description"
      [previewContent]="[
        {
          type: 'PARAGRAPH',
          content: question.feedbackProviderInstructions ? getTranslatedValue(question.feedbackProviderInstructions) : null,
        },
      ]"
    >
    </ptl-resource-preview>
  } @else {
    <ptl-resource-preview class="question-description" [previewContent]="[{ type: 'PARAGRAPH', content: instruction }]">
    </ptl-resource-preview>
  }

  @if (question) {
    <div class="options-container">
      @if (question.showListTitle !== false) {
        <div class="title medium" [class.with-select]="question.presentationMode === 'SELECTABLE_DROP_DOWN'">
          {{ question.listTitle }}
        </div>
      }

      @switch (question.presentationMode) {
        @case ('SELECTABLE_DROP_DOWN') {
          <ptl-custom-select
            class="select-options"
            [multiple]="question.selectionLimit > 1"
            [maxSelection]="question.selectionLimit"
            [(value)]="selectedMultiple"
            (valueChange)="onSelectChange()"
            [options]="options"
          ></ptl-custom-select>
        }
        @case ('CHECKBOX') {
          <div class="checkbox-options">
            @for (option of options; track option.uid) {
              <mat-checkbox
                [(ngModel)]="option.selected"
                (change)="onCheckboxChange(option)"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isCheckboxDisabled(option)"
                tabindex="0"
                color="primary"
                class="extra-small"
              >
                <span>{{ option.title }}</span>
              </mat-checkbox>
            }
          </div>
        }
        @case ('RADIO') {
          <mat-radio-group [(ngModel)]="selectedRadioItem" class="radio-options" (ngModelChange)="onRadioChange()">
            @for (option of options; track option.uid) {
              <mat-radio-button class="radio-option" [value]="option" color="primary" name="listRadio" [tabIndex]="0">
                <span class="small">{{ option.title }}</span>
              </mat-radio-button>
            }
          </mat-radio-group>
        }
      }
    </div>
  }
</div>
